module.exports = __webpack_public_path__ + "media/images/contact-banner-a4317dd9f1b7c864bebba3f5bf784ec7.svg";